import { render, staticRenderFns } from "./AllCreditNotesTable.vue?vue&type=template&id=5f01607c&scoped=true"
import script from "./AllCreditNotesTable.vue?vue&type=script&lang=js"
export * from "./AllCreditNotesTable.vue?vue&type=script&lang=js"
import style0 from "./AllCreditNotesTable.vue?vue&type=style&index=0&id=5f01607c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f01607c",
  null
  
)

export default component.exports